import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { menuBuilderShoppingListCopy as copy } from 'src/constants/menuBuilderCopy'

const ShoppingListGuidanceBanner = ({ venueId }) => (
  <Banner>
    <Title>{copy.guidanceBannerTitle}</Title>
    <Body>{copy.guidanceBannerBody}</Body>
    {venueId ? (
      <CatalogueLink to={`/v/${venueId}/catalogue`}>
        {copy.guidanceBannerCta}
      </CatalogueLink>
    ) : null}
  </Banner>
)

const Banner = styled.div`
  background: #f9fff0;
  border: 1px solid rgba(181, 217, 34, 0.55);
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 16px;
`

const Title = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: #3d5c00;
  margin-bottom: 4px;
`

const Body = styled.div`
  font-size: 13px;
  line-height: 1.45;
  color: #3d5c00;
`

const CatalogueLink = styled(Link)`
  display: inline-block;
  margin-top: 10px;
  padding: 6px 12px;
  border-radius: 6px;
  background: #b5d922;
  color: #1a1a1a;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    color: #1a1a1a;
    opacity: 0.92;
  }
`

export default ShoppingListGuidanceBanner
